document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.menu-drawer__tab');
  const contents = document.querySelectorAll('.menu-drawer__menu-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      contents.forEach(c => c.classList.add('hidden'));
      contents.forEach(c => c.classList.remove('active'));

      tab.classList.add('active');
      const target = document.querySelector(`.menu-drawer__menu-content[data-content="${tab.dataset.target}"]`);
      if (target) {
        target.classList.remove('hidden');
        target.classList.add('active');
      }
    });
  });
});
